export const careplanConstants = {
  FCP_ADD_SET: 'FCP_ADD_SET',
  FCP_SET_FAVORITE: 'FCP_SET_FAVORITE',
  FCP_CLEAR_CURRENT: 'FCP_CLEAR_CURRENT',
  FCP_SET_CURRENT: 'FCP_SET_CURRENT',

  FCP_SET_FILES: 'FCP_SET_FILES',
  FCP_SET_PHYSICAL_EXAM: 'FCP_SET_PHYSICAL_EXAM',
  FCP_SET_IMAGING: 'FCP_SET_IMAGING',
  FCP_SET_DIAGNOSIS: 'FCP_SET_DIAGNOSIS',
  FCP_SET_CARE_PLAN: 'FCP_SET_CARE_PLAN',
  FCP_SET_ATTACHMENTS: 'FCP_SET_ATTACHMENTS',

  FCP_RETRIEVE_SUCCESS: 'FCP_RETRIEVE_SUCCESS',
  FCP_RETRIEVE_FAILURE: 'FCP_RETRIEVE_FAILURE'
}